var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"canvasdemo"},[_c('h2',{staticClass:"tit"},[_vm._v("拆线图 Demo")]),_c('div',{staticClass:"char"},[_c('div',{staticClass:"content"},[_c('char',{attrs:{"charData":_vm.charData}})],1)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b16124e2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Canvas.vue
// module id = null
// module chunks = 